module.exports = __webpack_public_path__ + "media/bootstrap-icons/door-open-8a9048a9.svg";